import React, { Component } from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import compose from "lodash.flowright";
import { Container } from "react-bootstrap";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import ExamReportSection from "../home/ExamReportSection";
import PreloaderTwo from "../preloader/PreloaderTwo";
import "../home/reports/_report.scss";

/* ──────────────────────────────────────────────────────────────────────────
   Test Reports — embeds the /ExamReport_tabs module (Report.jsx) inside the
   Management MIS Reports "Test Reports" tab. Self-contained data layer mirrors
   Report.jsx; renders the content (Exam Wise / Overall) without page chrome.
   ────────────────────────────────────────────────────────────────────────── */

const FETCH_GLOBALS = gql`
  query($institution_id: Int!) {
    globals(institution_id: $institution_id) {
      b_e_c_s_data { section_id class_id branch_id exam_id state_id city_id district_id }
      educationalClasses { id class }
      globalPackages { id package_name exams_covered }
      globalCategories { id category_name package_id }
      classes { id class }
      exams { id exam exam_subjects { subject_id } }
      globalBranches { id branch_name state_id city_id district_id }
      globalSections { id section_name branch_id category_id package_id }
      offlineExamSubjects { id subject }
      offlineFeeTypes { id fee_type }
      states { state_id state_name }
      districts { id district_name state_id }
      cities { id district_id region_id city_name timestamp }
    }
  }
`;

const FETCH_EXAMS = gql`
  query($institution_id: Int!) {
    getDashBoardExams(institution_id: $institution_id) {
      quiz_exams { id exam_name exam_type class_id start_time }
      full_exams {
        id exam_mode exam_name exam_type class_id start_time end_time
        section { id section_name branch_id exam_id }
      }
    }
  }
`;

class TestReportsTab extends Component {
  constructor(props) {
    super(props);
    this.state = { activeTab: "exam_wise_report" };
  }

  handleTabChange = (key) => this.setState({ activeTab: key });

  render() {
    const { globals } = this.props;
    const getDashBoardExams = this.props.getDashBoardExams.getDashBoardExams || [];

    const propsData = {
      classes: globals.globals?.classes || [],
      exams: globals.globals?.exams || [],
      testTypes: { value: 1, label: "Full Exams" },
    };
    const testTypes = [{ value: 1, label: "Full Exams" }];

    const ready = globals?.globals?.exams?.length > 0 && getDashBoardExams && getDashBoardExams?.full_exams?.length > 0;

    if (!ready) {
      return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: 360 }}>
          <PreloaderTwo />
        </div>
      );
    }

    const TABS = [
      { value: "exam_wise_report", label: "Exam Wise Report", icon: "fas fa-file" },
    ];

    return (
      <Container fluid className="adaptive-report-wrapper">
        <div style={{ background: "#f8fafc", border: "1.5px solid #e2e8f0", borderRadius: 12, padding: "12px 16px 0 16px", marginTop: 16 }}>
          <ul className="nav nav-tabs" style={{ borderBottom: "none", gap: 8 }}>
            {TABS.map((tab) => {
              const isActive = this.state.activeTab === tab.value;
              return (
                <li className="nav-item" key={tab.value}>
                  <a
                    className={`nav-link ${isActive ? "active" : ""}`}
                    href="#"
                    onClick={(e) => { e.preventDefault(); this.handleTabChange(tab.value); }}
                    style={{
                      cursor: "pointer", fontWeight: 700, fontSize: 14,
                      display: "flex", alignItems: "center", gap: 8, padding: "12px 20px",
                      color: isActive ? "#6366f1" : "#4b5563",
                      background: isActive ? "#fff" : "transparent",
                      borderColor: isActive ? "#e2e8f0 #e2e8f0 #fff" : "transparent",
                      borderWidth: "1.5px", borderBottomWidth: isActive ? "2px" : "1.5px",
                      borderRadius: "10px 10px 0 0", transition: "all 0.15s ease", marginBottom: "-1.5px",
                    }}
                  >
                    <i className={tab.icon} />
                    {tab.label}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>

        <div className="mt-3">
          {this.state.activeTab === "exam_wise_report" && (
            <ExamReportSection globals={propsData} stateData={{ eexamptype: 1 }} getDashBoardExams={getDashBoardExams} testTypes={testTypes} />
          )}
        </div>
      </Container>
    );
  }
}

export default compose(
  withRouter,
  graphql(FETCH_GLOBALS, {
    options: () => ({ variables: { institution_id: parseInt(Cookies.get("institutionid")) } }),
    name: "globals",
  }),
  graphql(FETCH_EXAMS, {
    options: () => ({ variables: { institution_id: parseInt(Cookies.get("institutionid")) } }),
    name: "getDashBoardExams",
  }),
)(TestReportsTab);
